import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./bem-tipos.component.html')
})
export class BemTiposComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/bem-tipos.component.ts
 **/